import axiosInstance from "../../utils/axiosInstance";

const getRedemCodes = async (params) => {
  const response = await axiosInstance.get(
    `redem-code?limit=${params.pageSize}&skip=${
      (params.current - 1) * params.pageSize
    }&key=${params.key}&status=${params.status}`
  );
  return response.data.data;
};

const getRedemCode = async (id) => {
  const response = await axiosInstance.get(`redem-code/${id}`);
  return response.data.data;
};

const createRedemCode = async (data) => {
  const response = await axiosInstance.post(`redem-code`, data);
  return response.data.data;
};

const updateRedemCode = async (params) => {
  const response = await axiosInstance.put(`redem-code/${params.id}`, params.data);
  return response.data.data;
};

const deleteRedemCode = async (params) => {
  const response = await axiosInstance.delete(`redem-code/${params.id}`);
  return response.data.data;
};

const updateRedemCodeStatus = async (params) => {
  const response = await axiosInstance.put(`redem-code/${params.id}`, params.data);
  return response.data.data;
};

const redemCodeService = {
  getRedemCodes,
  updateRedemCode,
  createRedemCode,
  updateRedemCodeStatus,
  getRedemCode,
  deleteRedemCode,
};

export default redemCodeService;
